import { onMounted, onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'

interface KeyAction {
  key: string
  action: () => void
  preventDefault?: boolean
}

export const useGlobalKeymap = () => {
  const store = useStore()

  const toggleSecondaryNav = () => {
    try {
      const newValue = !store.getters['secondaryNavigationModule/isSecondaryNavigationVisible']
      store.commit('secondaryNavigationModule/SET_IS_SECONDARY_NAVIGATION_VISIBLE', newValue)

      try {
        localStorage.setItem('secondaryNavVisible', JSON.stringify(newValue))
      }
      catch (e) {
        console.error('Failed to save secondary nav state to localStorage:', e)
      }
    }
    catch (error) {
      console.error('Error toggling secondary navigation visibility:', error)
    }
  }

  const keyActions: KeyAction[] = [
    {
      key: '[',
      action: toggleSecondaryNav,
      preventDefault: true,
    },
  ]

  const handleGlobalKeydown = (event: KeyboardEvent) => {
    // Skip if user is typing in an input field
    const activeElement = document.activeElement as HTMLElement
    const isInputFocused = activeElement && (
      activeElement.tagName === 'INPUT'
      || activeElement.tagName === 'TEXTAREA'
      || activeElement.isContentEditable
      || activeElement.getAttribute('contenteditable') === 'true'
    )

    if (isInputFocused) {
      return
    }

    const matchingAction = keyActions.find(action => action.key === event.key)

    if (matchingAction) {
      if (matchingAction.preventDefault) {
        event.preventDefault()
      }
      matchingAction.action()
    }
  }

  const setupGlobalKeymap = () => {
    window.addEventListener('keydown', handleGlobalKeydown)
  }

  const cleanupGlobalKeymap = () => {
    window.removeEventListener('keydown', handleGlobalKeydown)
  }

  onMounted(setupGlobalKeymap)
  onBeforeUnmount(cleanupGlobalKeymap)

  return {
    setupGlobalKeymap,
    cleanupGlobalKeymap,
    toggleSecondaryNav,
  }
}
